import type { SupabaseClient } from '@supabase/supabase-js'
import type { SetSession } from '@/modules/auth/use-cases'

export class SupabaseSetSessionRepository {
  constructor(private readonly client: SupabaseClient) {}

  execute: SetSession = async ({ accessToken, refreshToken }) => {
    const { error } = await this.client.auth.setSession({
      access_token: accessToken,
      refresh_token: refreshToken,
    })
    if (error) {
      throw error
    }
  }
}
